<template>
  <v-container fluid>
    <!-- Aviso de dados pré-preenchidos do protocolo -->
    <v-alert
      v-if="isPrefilledAndLocked"
      :value="true"
      type="info"
      outline
      class="mb-4"
    >
      <v-layout align-center>
        <v-icon left>mdi-lock</v-icon>
        <div>
          Os dados do solicitante foram preenchidos automaticamente a partir do protocolo REDESIM.
          <br>
          <span class="caption">Estes campos não podem ser alterados.</span>
        </div>
      </v-layout>
    </v-alert>

    <span class="title -tongue ml-5 d-block">
      Para qual CPF ou CNPJ será feito o requerimento?
    </span>
    <span class="grey--text">
      A pessoa física ou jurídica escolhida será o interessado deste requerimento.
    </span>
    <v-form ref="form" v-model="valid">
      <v-form ref="cpfCnpjForm" v-model="cpfCnpjFormValid">
        <v-layout row class="mb-2">

          <v-flex xs4>
            <v-text-field
                label="CPF ou CNPJ"
                v-model="cpfCnpj"
                :mask="cpfCnpj.length >= 12 ? cnpjMask : cpfMask"
                prepend-icon="mdi-magnify"
                :rules="[validationRules.cpfCnpj]"
                :disabled="isPrefilledAndLocked"
                :background-color="isPrefilledAndLocked ? '#f5f5f5' : ''"
                required
            >
              <template v-if="isPrefilledAndLocked" v-slot:append>
                <v-icon small color="grey">mdi-lock</v-icon>
              </template>
            </v-text-field>
          </v-flex>
          <v-flex xs2>
            <v-btn
                fab
                small
                color="primary"
                :disabled="!cpfCnpjFormValid || isPrefilledAndLocked"
                @click="fetchCpfCnpj()">
              <v-icon>mdi-magnify</v-icon>
            </v-btn>
          </v-flex>
        </v-layout>
      </v-form>

      <div v-if="showEntity">
        <v-layout>
          <v-flex xs6>
            <v-text-field
                label="Email"
                v-model="email"
                prepend-icon="mdi-email"
                :rules="[validationRules.required, validationRules.email]"
                :disabled="entity.email != null || isPrefilledAndLocked"
                :background-color="isPrefilledAndLocked ? '#f5f5f5' : ''"
                required
            >
              <template v-if="isPrefilledAndLocked" v-slot:append>
                <v-icon small color="grey">mdi-lock</v-icon>
              </template>
            </v-text-field>
          </v-flex>
        </v-layout>

        <v-layout>
          <v-flex xs6>
            <v-text-field
                label="Nome Completo / Razão Social"
                v-model="entity.name"
                :rules="[validationRules.required]"
                :disabled="!needCreateEntity || isPrefilledAndLocked"
                :background-color="isPrefilledAndLocked ? '#f5f5f5' : ''"
                prepend-icon="mdi-account"
                required
            >
              <template v-if="isPrefilledAndLocked" v-slot:append>
                <v-icon small color="grey">mdi-lock</v-icon>
              </template>
            </v-text-field>
          </v-flex>

        </v-layout>

        <v-layout class="mb-4" v-if="cpfCnpj.length == 14">
          <v-flex xs6 sm6 d-flex>
            <v-select
                :items="enquadramentos"
                v-model="entity.enquadramento"
                :rules="[validationRules.required]"
                prepend-icon="mdi-domain"
                label="Enquadramento"
            ></v-select>
          </v-flex>
        </v-layout>

        <v-layout>
          <v-flex xs6>
            <header class="headline">
              <h5 class="title">
                <v-icon class="mr-2">mdi-map-marker</v-icon>
                Qual o endereço?
              </h5>
            </header>

            <v-card class="mb-5">
              <v-container grid-list-lg>
                <v-layout row>
                  <v-flex xs4>
                    <v-text-field
                        v-model="entityAddress.zip_code"
                        label="CEP"
                        mask="##.###-###"
                        :rules="[validationRules.required]"
                        :disabled="!needCreateEntity || isPrefilledAndLocked"
                        :background-color="isPrefilledAndLocked ? '#f5f5f5' : ''"
                    >
                      <template v-if="isPrefilledAndLocked" v-slot:append>
                        <v-icon small color="grey">mdi-lock</v-icon>
                      </template>
                    </v-text-field>
                  </v-flex>
                  <v-flex>
                    <v-btn
                        fab
                        small
                        primary
                        color="primary"
                        :disabled="entityAddress.zip_code.length !== 8 || !needCreateEntity || isPrefilledAndLocked"
                        @click="fetchZipCodeForEntityAddress()"
                    >
                      <v-icon>mdi-magnify</v-icon>
                    </v-btn>
                  </v-flex>
                </v-layout>
                <v-layout row>
                  <v-flex xs8>
                    <v-text-field
                        v-model="entityAddress.street"
                        label="Logradouro"
                        :rules="[validationRules.required]"
                        :disabled="!needCreateEntity || isPrefilledAndLocked"
                        :background-color="isPrefilledAndLocked ? '#f5f5f5' : ''"
                    >
                      <template v-if="isPrefilledAndLocked" v-slot:append>
                        <v-icon small color="grey">mdi-lock</v-icon>
                      </template>
                    </v-text-field>
                  </v-flex>

                  <v-flex xs4>
                    <v-text-field
                        v-model="entityAddress.number"
                        label="Número"
                        :rules="[validationRules.required]"
                        :disabled="!needCreateEntity || isPrefilledAndLocked"
                        :background-color="isPrefilledAndLocked ? '#f5f5f5' : ''"
                    >
                      <template v-if="isPrefilledAndLocked" v-slot:append>
                        <v-icon small color="grey">mdi-lock</v-icon>
                      </template>
                    </v-text-field>
                  </v-flex>
                </v-layout>
                <v-layout row>
                  <v-flex xs6>
                    <v-text-field
                        v-model="entityAddress.complement"
                        label="Complemento"
                        :disabled="!needCreateEntity || isPrefilledAndLocked"
                        :background-color="isPrefilledAndLocked ? '#f5f5f5' : ''"
                    >
                      <template v-if="isPrefilledAndLocked" v-slot:append>
                        <v-icon small color="grey">mdi-lock</v-icon>
                      </template>
                    </v-text-field>
                  </v-flex>
                  <v-flex xs6>
                    <v-text-field
                        v-model="entityAddress.neighborhood"
                        label="Bairro"
                        :disabled="!needCreateEntity || isPrefilledAndLocked"
                        :background-color="isPrefilledAndLocked ? '#f5f5f5' : ''"
                        :rules="[validationRules.required]"
                    >
                      <template v-if="isPrefilledAndLocked" v-slot:append>
                        <v-icon small color="grey">mdi-lock</v-icon>
                      </template>
                    </v-text-field>
                  </v-flex>
                </v-layout>
                <v-layout row>
                  <v-flex xs4>
                    <v-autocomplete
                        :items="federalUnits"
                        v-model="entityAddress.federal_unit"
                        @change="fetchCities(entityAddress.federal_unit)"
                        :disabled="!needCreateEntity || isPrefilledAndLocked"
                        :background-color="isPrefilledAndLocked ? '#f5f5f5' : ''"
                        :rules="[validationRules.required]"
                        label="Selecione um estado"
                        no-data-text="Nenhum resultado encontrado"
                        item-text="name"
                        item-value="id"
                        return-object
                        single-line
                    >
                      <template v-if="isPrefilledAndLocked" v-slot:append>
                        <v-icon small color="grey">mdi-lock</v-icon>
                      </template>
                    </v-autocomplete>
                  </v-flex>
                  <v-flex xs8>
                    <v-autocomplete
                        v-model="entityAddress.city"
                        :items="otherCities"
                        :rules="[validationRules.required]"
                        :disabled="!needCreateEntity || isPrefilledAndLocked"
                        :background-color="isPrefilledAndLocked ? '#f5f5f5' : ''"
                        label="Selecione uma cidade"
                        no-data-text="Nenhum resultado encontrado"
                        item-text="name"
                        item-value="id"
                        return-object
                        single-line
                    >
                      <template v-if="isPrefilledAndLocked" v-slot:append>
                        <v-icon small color="grey">mdi-lock</v-icon>
                      </template>
                    </v-autocomplete>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card>
          </v-flex>
        </v-layout>

        <v-layout column>
          <h3 class="title">
            O requerimento é referente a uma solicitação de ATPP/ATRP?
          </h3>
          <v-flex xs3>
            <v-radio-group row
                           v-model="isApplicationAddressRequired">
              <v-radio label="Não" :value="true"/>
              <v-radio label="Sim" :value="false"/>
            </v-radio-group>
          </v-flex>
        </v-layout>

        <v-layout column
                  v-if="isApplicationAddressRequired">
          <h3 class="title">
            Informe as Coordenadas Geográficas (SIRGAS 2000)
          </h3>
          <v-layout>
            <v-flex xs2
                    class="mr-1"
            >
              <v-text-field
                  v-model="latitude"
                  label="Latitude"
                  :rules="[validationRules.required]"
              >
              </v-text-field>
            </v-flex>
            <v-flex xs2
                    class="ml-1"
            >
              <v-text-field
                  v-model="longitude"
                  label="Longitude"
                  :rules="[validationRules.required]"
              >
              </v-text-field>
            </v-flex>
          </v-layout>


        </v-layout>

        <v-layout column
                  v-if="isApplicationAddressRequired">
          <h3 class="title">
            O empreendimento, evento ou obra é localizado em outro endereço,
            diferente do informado acima?
          </h3>
          <v-flex xs3>
            <v-radio-group
                v-model="isApplicationAddressDifferent"
                row
            >
              <v-radio label="Não" :value="false"/>
              <v-radio label="Sim" :value="true"/>
            </v-radio-group>
          </v-flex>
        </v-layout>

        <v-layout v-if="isApplicationAddressDifferent">
          <v-flex xs6>
            <header class="headline">
              <h5 class="title">
                <v-icon class="mr-2">mdi-map-marker</v-icon>
                Endereço do Local
              </h5>
            </header>
            <v-card class="mb-5">
              <v-container grid-list-lg>
                <v-layout row>
                  <v-flex xs6>
                    <v-text-field
                        label="CEP"
                        append-icon="mdi-magnify"
                        mask="#####-###"
                        :rules="[validationRules.required, validationRules.postalcode]"
                        @change="fetchZipCodeForApplicationAddress()"
                        v-model="applicationAddress.zip_code"
                    />
                  </v-flex>
                  <v-flex xs2>
                    <v-btn
                        fab
                        small
                        primary
                        color="primary"
                        :disabled="applicationAddress.zip_code.length !== 8"
                        @click="fetchZipCodeForApplicationAddress()"
                    >
                      <v-icon>mdi-magnify</v-icon>
                    </v-btn>
                  </v-flex>

                </v-layout>

                <v-layout row>
                  <v-flex xs8>
                    <v-text-field
                        label="Logradouro"
                        :rules="[validationRules.required]"
                        v-model="applicationAddress.street"
                    />
                  </v-flex>

                  <v-flex xs4>
                    <v-text-field
                        v-model="applicationAddress.number"
                        label="Número"
                        :rules="[validationRules.required]"
                    />
                  </v-flex>
                </v-layout>

                <v-layout row>
                  <v-flex xs6>
                    <v-text-field
                        v-model="applicationAddress.complement"
                        label="Complemento"/>
                  </v-flex>
                  <v-flex xs6>
                    <v-text-field
                        v-model="applicationAddress.neighborhood"
                        label="Bairro"
                        :rules="[validationRules.required]"
                    />
                  </v-flex>
                </v-layout>

                <v-layout row>
                  <v-flex xs8>
                    <v-autocomplete
                        :items="alagoasCities"
                        v-model="applicationAddress.city"
                        :rules="[validationRules.required]"
                        label="Digite para buscar e selecione uma opção"
                        no-data-text="Nenhum resultado encontrado"
                        item-text="name"
                        item-value="id"
                        return-object
                        single-line
                    />
                  </v-flex>

                  <v-flex xs4>
                    <v-text-field
                        label="Estado"
                        :disabled="true"
                        v-model="applicationAddress.federal_unit.name"
                    />
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card>
          </v-flex>
        </v-layout>

      </div>

      <v-divider class="mt-3 mb-3"/>

      <v-flex xs6>
        <v-layout justify-space-between>
          <v-btn flat :to="{path: '/'}">Cancelar</v-btn>
          <v-btn
              :disabled="!isStepValid"
              color="primary"
              @click="mountEntity()"
          >
            Continuar
            <v-icon right>mdi-arrow-right mdi-18px</v-icon>
          </v-btn>
        </v-layout>
      </v-flex>
    </v-form>
  </v-container>
</template>

<script>
  import EntityService from '@/services/EntityService';
  import FederalUnitService from '@/services/FederalUnitService';
  import AddressService from '@/services/AddressService';
  import { isEmpty, find } from 'lodash';
  import validationRules from '@/mixins/validation-rules';
  import { mapActions, mapGetters } from 'vuex';

  export default {
    name: 'EntityStep',
    mixins: [validationRules],
    async beforeCreate() {
      this.federalUnits = await FederalUnitService.fetchFederalUnits();
    },
    async mounted() {
      // Pré-preenche os campos se houver dados do protocolo
      await this.prefillFromProtocolo();
    },
    data() {
      return {
        valid: false,
        cpfCnpjFormValid: false,
        cpfCnpj: '',
        cpfMask: '###.###.###-###',
        cnpjMask: '##.###.###/####-##',
        email: '',
        validationRules,
        federalUnits: [],
        alagoasCities: [],
        otherCities: [],
        isApplicationAddressRequired: true,
        isApplicationAddressDifferent: false,
        showEntity: false,

        entity: { id: '', enquadramento: null, email: null },
        entityAddress: { zip_code: '' },
        applicationAddress: { zip_code: '', federal_unit: { name: '' } },

        needCreateEntity: false,

        latitude: '',
        longitude: '',

        enquadramentos: [
          'Não possui', 'ME', 'EPP', 'MEI',
        ],
      };
    },
    methods: {
      ...mapActions('newApplication', ['setEntity', 'setApplicationAddress', 'nextStep', 'setValidSteps']),
      async prefillFromProtocolo() {
        // Verifica se há dados pré-preenchidos do protocolo no store
        const storeNewApplication = this.$store.state.newApplication.newApplication;

        if (this.prefilledFromProtocolo && storeNewApplication.entity) {
          const entity = storeNewApplication.entity;
          const address = storeNewApplication.applicationAddress;

          // Preenche os dados da entidade
          this.cpfCnpj = entity.cpf_cnpj || '';
          this.email = entity.email || '';
          this.entity = {
            id: entity.id,
            name: entity.name,
            enquadramento: entity.enquadramento,
            email: entity.email
          };

          // Preenche o endereço se disponível
          if (address) {
            // Carrega as cidades do estado
            if (address.federal_unit) {
              this.otherCities = await FederalUnitService.fetchCities(address.federal_unit.id);
            }

            this.entityAddress = {
              id: address.id,
              zip_code: address.zip_code || '',
              street: address.street || '',
              number: address.number || '',
              complement: address.complement || '',
              neighborhood: address.neighborhood || '',
              federal_unit: address.federal_unit,
              city: address.city,
              latitude: address.latitude,
              longitude: address.longitude
            };

            // Preenche coordenadas
            this.latitude = address.latitude || '';
            this.longitude = address.longitude || '';
          }

          // Mostra os campos da entidade
          this.showEntity = true;
          this.needCreateEntity = false;
        }
      },
      async fetchZipCodeForEntityAddress() {
        try {
          this.$store.dispatch('setLoadingDialog', true);

          const address = await AddressService.fetchZipCode(this.entityAddress.zip_code)
          const federalUnitForEntityAddress = find(this.federalUnits, { acronym: address.acronym })
          this.otherCities = await FederalUnitService.fetchCities(federalUnitForEntityAddress.id)
          const cityForEntityAddress = find(this.otherCities, { name: address.city })

          this.entityAddress = {
            ...address,
            federal_unit: federalUnitForEntityAddress,
            city: cityForEntityAddress,
            latitude: this.latitude,
            longitude: this.longitude
          }

        } catch (e) {
          alert('Erro ao Consultar CEP da Pessoa Física ou Jurídica')
        }
        this.$store.dispatch('setLoadingDialog', false);
      },
      async fetchZipCodeForApplicationAddress() {
        try {
          this.$store.dispatch('setLoadingDialog', true);

          const address = await AddressService.fetchZipCode(this.applicationAddress.zip_code)

          if (address.zip_code) {

            const federalUnitForApplicationAddress = find(this.federalUnits, { acronym: address.acronym })
            this.alagoasCities = await FederalUnitService.fetchCities(federalUnitForApplicationAddress.id)
            const cityForApplicationAddress = find(this.otherCities, { name: address.city })
            this.applicationAddress = {
              ...address,
              federal_unit: federalUnitForApplicationAddress,
              city: cityForApplicationAddress
            }
          } else {
            this.$swal({
              title: 'Atenção!',
              text: 'CEP não cadastrado na nossa base. Preencha os campos abaixo para poder continuar!',
              type: 'error'
            });
          }
        } catch (e) {
          alert('2')
        }
        this.$store.dispatch('setLoadingDialog', false);
      },
      async fetchCpfCnpj() {
        this.entityAddress = { zip_code: '' }
        this.$store.dispatch('setLoadingDialog', true);
        this.showEntity = true;
        this.needCreateEntity = false;

        const vm = this

        EntityService
          .fetch(this.cpfCnpj)
          .then(async ({ data }) => {
            const cityForEntityAddress = await vm.findCityForEntityAddress(data);

            vm.email = data.email;
            vm.entity = {
              id: data.id,
              name: data.name,
              cpfCnpj: this.cpfCnpj,
              email: data.email,
              enquadramento: data.enquadramento
            };
            vm.entityAddress = { 
              ...data.address,
              city: cityForEntityAddress
            };

            vm.isApplicationAddressDifferent = data.address.federal_unit.name !== 'Alagoas';
            vm.$store.dispatch('setLoadingDialog', false);
          })
          .catch(() => {
            vm.needCreateEntity = true
            if (this.cpfCnpj.length === 14) {
              vm.fetchDataFromReceita();
            } else {
              vm.showSwalError('CPF não localizado', 'Por favor, realize o preenchimento dos campos necessários')
              vm.$store.dispatch('setLoadingDialog', false);
            }
          })
      },
      async findCityForEntityAddress(entity) {
        const federalUnitForEntityAddress = find(this.federalUnits, { name: entity.address.federal_unit.name })
        this.otherCities = await FederalUnitService.fetchCities(federalUnitForEntityAddress.id)
        const cityForEntityAddress = find(this.otherCities, { name: entity.address.city.name })
        return cityForEntityAddress;
      },
      async fetchDataFromReceita() {
        const response = await EntityService.fetchDataFromReceita(this.cpfCnpj)
        if (response.data) {
          this.entity = { id: '', name: response.data.nome }
          this.entityAddress = {
            complement: response.data.complemento,
            neighborhood: response.data.bairro,
            number: response.data.numero,
            street: response.data.logradouro,
            zip_code: response.data.cep.replace(/[.-]/g, ''),
          }
          this.fetchZipCodeForEntityAddress();
        } else {
          this.showSwalError('CNPJ não localizado', 'Não foi possível obter seus dados da Receita Federal. Por favor, realize o preenchimento dos campos necessários')
        }
        this.$store.dispatch('setLoadingDialog', false);
      },
      async fetchCities(federal_unit) {
        this.otherCities = await FederalUnitService.fetchCities(federal_unit.id)
      },
      showSwalError(title, message) {
        this.$swal({
          title,
          text: message,
          type: 'error'
        })
      },
      async mountEntity() {

        try {

          if (isEmpty(this.entity.id) && !Number.isInteger(this.entity.id)) {
            const payloadEntity = { ...this.entity, address: this.entityAddress, cpf_cnpj: this.cpfCnpj, email: this.email }
            const responseEntityService = await EntityService.create(payloadEntity)
            this.entity.id = responseEntityService.id;
          }

          this.entity = { ...this.entity, cpf_cnpj: this.cpfCnpj, email: this.email }
          let applicationAddress = this.isApplicationAddressDifferent ? this.applicationAddress : this.entityAddress
          applicationAddress = { ...applicationAddress, latitude: this.latitude, longitude: this.longitude }

          this.setEntity({ ...this.entity, address: this.entityAddress });
          this.setApplicationAddress(applicationAddress);
          this.nextStep();
        } catch (e) {
          this.$swal({
            title: 'Erro',
            text: 'Erro ao Cadastrar os dados da Empresa/Pessoa Física. Verifique se os dados estão corretos',
            type: 'error',
            showConfirmButton: 'Ok',
          });
        }

      },
    },
    computed: {
      ...mapGetters('newApplication', ['prefilledFromProtocolo', 'lockPrefilledFields']),
      isStepValid() {
        return this.valid && this.showEntity;
      },
      isPrefilledAndLocked() {
        return this.prefilledFromProtocolo && this.lockPrefilledFields;
      }
    },
    watch: {
      isApplicationAddressDifferent(newValue) {
        if (newValue) {
          this.applicationAddress = { zip_code: '', federal_unit: {} };
        } else {
          this.applicationAddress = this.entityAddress;
        }
      },
      valid() {
        this.setValidSteps(this.valid);
      }
    },
  };
</script>
